import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { IAPIArrayData, IAPIData } from '@shared/interfaces/api.interface';
import { ICard } from '@shared/interfaces/card.interface';
import { Card } from '@shared/models/card.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CardsService {
  private readonly ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/cards`
  );

  constructor(private readonly _http: HttpClient) {}

  public get(params?: HttpParams): Observable<ICard[]> {
    return this._http
      .get<IAPIArrayData>(this.ENDPOINT_V3, {
        params
      })
      .pipe(map((res: IAPIArrayData) => Card.fromAPIArray(res)));
  }

  public post(c: any): Observable<ICard> {
    return this._http
      .post<IAPIData>(this.ENDPOINT_V3, c.apiData)
      .pipe(map((res: IAPIData) => Card.fromAPI(res)));
  }
}
